import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import _ from 'lodash'
import moment from 'moment'
import {
  Button,
  Modal,
  Popconfirm,
  Tabs,
  Icon,
  Spin,
  Tooltip,
  Upload,
  Input,
  Form,
  Radio,
  Select
} from 'antd'
import ReactTable from 'react-table'
import numeral from 'numeral'
import PurchaseOrderEditor from './PurchaseOrderEditor'
import { arrayMove, filterCaseInsensitive, generateUniqueId, getModalId } from '../util'
import config from '../config'
import history from '../history'
import styled from 'styled-components'
import { TextMask, SpanAdapter } from 'react-text-mask-hoc'
import VendorAddressForm from '../components/VendorAddressForm'
import { actions as vendorActions } from '../redux/modules/jobFunctions/jobVendorActions'

const TabPane = Tabs.TabPane
const { TextArea } = Input
const FormItem = Form.Item
const FilesUploadContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  -webkit-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  -moz-box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
  box-shadow: 0px 0px 35px -12px rgba(204, 204, 204, 1);
`
const EditAttachmentContainer = styled.div`
  padding: 10px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #e2e2e2;
  background-color: #eeeeee;
`
const EditAttachmentTitle = styled.h6`
  color: #fff;
`
const EditingFileContainer = styled.div`
  margin: 10px 0;
`
const RadioButton = Radio.Button
const RadioGroup = Radio.Group
const Option = Select.Option
const { API_BASE } = config

const getSortedItems = items =>
  Array.isArray(items) ? items.sort((a, b) => a.order - b.order) : null

class VendorPanel extends Component {
  constructor(props) {
    super(props)
    this.state = {
      vendorId: 0,
      purchaseOrderId: getModalId(props.location.pathname),
      sectionData: [],
      panel: 'TablePanel',
      orderBasicInfo: {},
      isEditing: false,
      shipTo: undefined,
      currentRevisionNumberPrint: 1
    }
  }

  componentDidUpdate(prevProps) {
    // update the current version for printing
    if (prevProps.loadingRevision !== this.props.loadingRevision) {
      const { revisions } = this.props

      if (revisions && this.props.purchaseOrder) {
        this.setState({
          currentRevisionNumberPrint: revisions[revisions.length - 1].currentRevisionNumber,
          purchaseOrderItems: getSortedItems(this.props.purchaseOrder.purchase_order_items)
        })
      }
    }
  }

  componentDidMount() {
    const { jobId } = this.props.match.params
    this.props.getVendorPurchaseOrder({
      jobId: jobId,
      next: (err, payload) => {
        const { purchaseOrderId } = this.state
        if (purchaseOrderId) {
          if (!err) {
            const results = _.get(payload, 'data')
            const current = _.find(results, { id: parseInt(purchaseOrderId, 10) })
            this.props.getRevisions({
              targetId: purchaseOrderId,
              table: 'purchase_order'
            })
            this.props.getPurchaseOrder({
              purchaseOrderId: purchaseOrderId
            })
            this.props.handlePurchaseOrderOpenModal(purchaseOrderId)
            this.setState({
              purchaseOrderId: purchaseOrderId,
              orderBasicInfo: current,
              terms: current.terms,
              shipTo: current.shipping_address_id,
              description: current.description,
              attention: current.shipping_attention,
              addressData: {
                address1: current.address1,
                address2: current.address2,
                city: current.city,
                state: current.state,
                zip: current.zip
              }
            })
          }
        }
      }
    })
  }

  changeSectionPanel = panel => {
    this.setState({
      panel: panel
    })
  }

  onChangeItem = async (value, field, id) => {
    const items = _.cloneDeep(this.state.purchaseOrderItems)
    const currentItem = items.find(i => i.id === id)
    const index = items.indexOf(currentItem)
    items[index][field] = value
    await this.setState({
      purchaseOrderItems: items
    })
  }

  onChangeName = _.throttle((value, id) => {
    const items = _.cloneDeep(this.state.purchaseOrderItems)
    const currentItem = items.find(i => i.id === id)
    const selectedItem = this.props.allItems.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )
    if (selectedItem.length > 0) {
      currentItem.name = selectedItem[0].name
    }
    this.setState({
      purchaseOrderItems: items
    })
  }, 100)

  handleRowClick = row => {
    this.props.setVendorClicked(row.organization_id)
    const { jobType, jobId } = this.props.match.params
    this.props.getRevisions({
      targetId: row.id,
      table: 'purchase_order'
    })
    this.props.getPurchaseOrder({
      purchaseOrderId: row.id
    })
    this.props.handlePurchaseOrderOpenModal(row.id)

    this.setState({
      purchaseOrderId: row.id,
      orderBasicInfo: row,
      terms: row.terms,
      shipTo: row.shipping_address_id,
      description: row.description,
      attention: row.shipping_attention,
      addressData: {
        address1: row.address1,
        address2: row.address2,
        city: row.city,
        state: row.state,
        zip: row.zip
      }
    })

    history.push(`/jobView/${jobId}/${jobType}/vendors/purchase-order/modal/${row.id}`)
  }

  handleCancel = () => {
    const { jobType, jobId } = this.props.match.params
    this.props.handlePurchaseOrderCloseModal()
    this.setState({
      purchaseOrderId: 0,
      isEditing: false,
      purchaseOrderSections: null,
      purchaseOrderItems: null
    })

    history.push(`/jobView/${jobId}/${jobType}/vendors`)
  }

  getSectionSubTotal = items => {
    let sectionSubTotal = 0
    items.forEach(item => {
      sectionSubTotal += item.cost * item.quantity
    })
    return numeral(sectionSubTotal).format('$0,0.00')
  }

  handleEdit = () => {
    const itemsWithRowId = this.state.purchaseOrderItems.map(item => {
      return { ...item, row_id: generateUniqueId() }
    })
    this.setState({
      isEditing: true,
      purchaseOrderSections: this.state.purchaseOrderSections
        ? this.state.purchaseOrderSections
        : this.props.purchaseOrder.purchase_order_sections,
      purchaseOrderItems: itemsWithRowId
    })
  }

  handleSave = async () => {
    const basicInfoData = {
      description: this.state.description,
      terms: this.state.terms,
      shipping_address_id: this.state.shipTo,
      attention: this.state.attention
    }
    try {
      await this.props.handleSavePurchaseOrder(
        this.state.purchaseOrderId,
        this.state.purchaseOrderSections,
        this.state.purchaseOrderItems,
        basicInfoData
      )
      const newGrandTotal = this.state.purchaseOrderItems
        .filter(val => !val.markedForDeletion)
        .reduce((accu, currentVal) => {
          return accu + currentVal.cost * currentVal.quantity
        }, 0)
      const orderBasicInfo = {
        ...this.state.orderBasicInfo,
        grand_total: newGrandTotal
      }
      this.setState({
        isEditing: false,
        orderBasicInfo
      })
    } catch (error) {
      console.log(error)
      Raven.captureException(error)
    }
  }

  addSection = () => {
    const sectionArray = this.state.purchaseOrderSections
    sectionArray.push({ name: 'New Section' })
    this.setState({
      purchaseOrderSections: sectionArray
    })
  }
  deleteItemsRelatedToSection = (items, sectionId) => {
    return items.filter(item => item.purchase_order_section_id !== sectionId)
  }

  deleteSection = sectionId => {
    const sectionArray = this.state.purchaseOrderSections
    let orderBasicInfo = { ...this.state.orderBasicInfo }

    let sectionToDelete = sectionArray[_.findIndex(sectionArray, { id: sectionId })]

    let filteredItems = []

    sectionToDelete.markedForDeletion = true

    filteredItems = this.deleteItemsRelatedToSection(this.state.purchaseOrderItems, sectionId)

    const newGrandTotal = _.reduce(
      filteredItems,
      (sum, n) => {
        if (!n.markedForDeletion) {
          return sum + n.cost * n.quantity
        } else {
          return sum
        }
      },
      0
    )

    orderBasicInfo.grand_total = newGrandTotal
    this.setState({
      purchaseOrderSections: sectionArray,
      purchaseOrderItems: filteredItems,
      orderBasicInfo: orderBasicInfo
    })
  }

  moveSectionUp = sectionNumber => {
    const sectionArray = this.state.purchaseOrderSections
    const index = _.findIndex(sectionArray, { id: sectionNumber })
    this.setState({
      purchaseOrderSections: arrayMove(sectionArray, index, index - 1)
    })
  }

  moveSectionDown = sectionNumber => {
    const sectionArray = this.state.purchaseOrderSections
    const index = _.findIndex(sectionArray, { id: sectionNumber })
    this.setState({
      purchaseOrderSections: arrayMove(sectionArray, index, index + 1)
    })
  }

  addItem = (index, data) => {
    const { allItems } = this.props
    const itemsArray = this.state.purchaseOrderItems
    let orderData = { ...this.state.orderBasicInfo }
    data.purchase_order_section_id = index

    const selectedItem = allItems.find(item => item.id === parseInt(data.item_id, 10))

    data.name = selectedItem && selectedItem.name
    data.grand_total = data.cost * data.quantity
    data.row_id = generateUniqueId()
    itemsArray.push(data)

    orderData.grand_total = orderData.grand_total + data.cost * data.quantity

    this.setState({
      purchaseOrderItems: itemsArray,
      orderBasicInfo: orderData
    })
  }

  basicInfoInputChange = (value, input) => {
    this.setState({ [input]: value })
  }

  onSectionNameChange = (index, value) => {
    const groupArray = this.state.purchaseOrderSections
    groupArray[index].name = value

    this.setState({
      purchaseOrderSections: groupArray
    })
  }

  moveItemUp = rowId => {
    const itemsArray = [...this.state.purchaseOrderItems]
    this.setState({
      purchaseOrderItems: arrayMove(itemsArray, rowId, rowId - 1)
    })
  }

  moveItemDown = rowId => {
    const itemsArray = [...this.state.purchaseOrderItems]
    this.setState({
      purchaseOrderItems: arrayMove(itemsArray, rowId, rowId + 1)
    })
  }

  deleteItem = rowId => {
    const itemArray = [...this.state.purchaseOrderItems]

    let currentItem = itemArray.find(item => {
      return item.row_id === rowId
    })

    currentItem.markedForDeletion = true

    const newGrandTotal = _.reduce(
      itemArray,
      (sum, n) => {
        if (!n.markedForDeletion) {
          return sum + n.cost * n.quantity
        } else {
          return sum
        }
      },
      0
    )

    if (currentItem) {
      let orderData = { ...this.state.orderBasicInfo, grand_total: newGrandTotal }
      this.setState({
        purchaseOrderItems: itemArray,
        orderBasicInfo: orderData
      })
    }
  }

  handleTermsChange = event => {
    const { orderBasicInfo } = this.state
    let basicInfo = { ...orderBasicInfo }

    basicInfo.terms = event.target.value

    this.setState({
      terms: event.target.value,
      orderBasicInfo: basicInfo
    })
  }

  handleAttentionChange = event => {
    const { orderBasicInfo } = this.state
    let basicInfo = { ...orderBasicInfo }

    basicInfo.attention = event.target.value

    this.setState({
      attention: event.target.value,
      orderBasicInfo: basicInfo
    })
  }

  handleDescriptionChange = event => {
    const { orderBasicInfo } = this.state
    let basicInfo = { ...orderBasicInfo }

    basicInfo.description = event.target.value

    this.setState({
      description: event.target.value,
      orderBasicInfo: basicInfo
    })
  }

  handleShipToChange = value => {
    this.setState({ shipTo: value })
  }

  getSectionItems = sections => {
    const itemsArray = _.map(sections, section => section.items)
    return itemsArray.flat()
  }

  handleRevisionChange = value => {
    const { revisions } = this.props
    if (revisions.length) {
      const revision = revisions[value]

      // set revision for printing
      this.setState({
        currentRevisionNumberPrint: revision.currentRevisionNumber
      })

      let changes = {}
      _.forEach(revision, (fieldValue, fieldName) => {
        changes[fieldName] = fieldValue
      })

      const {
        attention,
        description,
        shipping_attention,
        terms,
        shipping_address_id,
        sections,
        shipping_address
      } = changes

      this.setState(prevState => {
        const purchaseOrderSections = sections ? sections : []

        const purchaseOrderItems = this.getSectionItems(sections)

        const newGrandTotal = purchaseOrderItems
          .filter(val => !val.markedForDeletion)
          .reduce((accu, currentVal) => {
            return accu + currentVal.cost * currentVal.quantity
          }, 0)
        const orderBasicInfo = {
          ...prevState.orderBasicInfo,
          terms: terms || prevState.orderBasicInfo.terms,
          shipping_address_id: +shipping_address_id || +prevState.shipTo,
          description: description || prevState.description,
          attention: attention || shipping_attention,
          grand_total: newGrandTotal
        }
        return {
          terms: terms || prevState.terms,
          shipTo: +shipping_address_id || +prevState.shipTo,
          description: description || prevState.description,
          attention: attention || shipping_attention,
          purchaseOrderSections,
          purchaseOrderItems,
          orderBasicInfo,
          addressData: shipping_address
        }
      })
    }
  }
  getPurchaseOrderSections = () => {
    const { purchaseOrder } = this.props
    const { purchaseOrderSections } = this.state

    return purchaseOrderSections || (purchaseOrder && purchaseOrder.purchase_order_sections) || []
  }
  getFilteredPurchaseOrderItems = section => {
    const { purchaseOrder } = this.props
    const { purchaseOrderItems } = this.state
    const filteredItems = (purchaseOrderItems || purchaseOrder.purchase_order_items || []).filter(
      row => row.purchase_order_section_id === section.id && !row.markedForDeletion
    )

    return filteredItems
  }
  vendorAdressForm = null

  renderSelectedShipping = isOtherShippingOption => {
    const { setVendorAdressForm } = this.props
    if (isOtherShippingOption) {
      return (
        <VendorAddressForm
          wrappedComponentRef={setVendorAdressForm}
          isDisabled={!this.state.isEditing}
          contentData={this.state.addressData}
        />
      )
    }
    return (
      <p>
        {`Attention to `}
        {!this.state.isEditing && <b>{this.state.attention}</b>}
        {this.state.isEditing && (
          <Input onChange={this.handleAttentionChange} value={this.state.attention} />
        )}
      </p>
    )
  }

  render() {
    const { vendor, vendorPurchaseOrders, handleAddPurchaseOrderClick } = this.props

    const { orderBasicInfo } = this.state
    const uploadProps = {
      multiple: true,
      showUploadList: false,
      data: { organizationId: vendor.organization_id }
    }
    const filteredData =
      vendorPurchaseOrders &&
      vendorPurchaseOrders.data.filter(row => row.organization_id === vendor.organization_id)
    const orderSections = this.getPurchaseOrderSections().map(section => {
      const filteredItems = this.getFilteredPurchaseOrderItems(section)
      return (
        <div key={section.id}>
          <div className="purchaseOrderSection flexSpaceBetween">{section.name}</div>
          <ReactTable
            showPagination={false}
            columns={[
              {
                columns: [
                  {
                    Header: 'Name',
                    id: 'name',
                    accessor: 'name',
                    Cell: d => <Tooltip title={d.original.name}>{d.original.name}</Tooltip>,
                    width: 300
                  },
                  {
                    Header: 'Description',
                    id: 'description',
                    accessor: 'description',
                    Cell: d => (
                      <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
                    )
                  },
                  {
                    Header: 'Cost',
                    id: 'cost',
                    accessor: d => {
                      const r = numeral(d.cost).format('$0,0.00')
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 100,
                    className: 'textAlignRight'
                  },
                  {
                    Header: 'Quantity',
                    id: 'qty',
                    accessor: d => <Tooltip title={d.quantity}>{d.quantity}</Tooltip>,
                    width: 100,
                    className: 'textAlignRight'
                  },
                  {
                    Header: 'Grand Total',
                    id: 'grand_total',
                    accessor: d => {
                      const r = numeral(d.cost * d.quantity).format('$0,0.00')
                      return <Tooltip title={r}>{r}</Tooltip>
                    },
                    width: 120,
                    className: 'textAlignRight'
                  }
                ]
              }
            ]}
            data={filteredItems}
            defaultFilterMethod={filterCaseInsensitive}
            noDataText="No items added yet"
            pageSize={filteredItems.length}
            className="-striped -highlight"
          />
          <div className="sectionFooter">
            Section Sub-Total: <b>{this.getSectionSubTotal(filteredItems)}</b>
          </div>
        </div>
      )
    })
    let isOtherShippingOption = false

    let shipTo = ''
    switch (this.state.shipTo) {
      case 1:
        shipTo = 'G-Tech'
        break
      case 2:
        shipTo = 'Jobsite'
        break
      case 3:
        shipTo = 'Client'
        break
      default:
        isOtherShippingOption = true
        shipTo = 'Other'
        break
    }
    const { loadingRevision, revisions } = this.props

    return (
      <div>
        <Modal
          visible={this.props.shouldRenderModal(vendor.organization_id)}
          title="Purchase Order"
          footer={null}
          onCancel={this.handleCancel}
          width={'90%'}
          maskClosable={false}
        >
          <div id="divToPrint">
            <div className="flexSpaceBetween">
              <h2 className="marginBottom0">PO #{orderBasicInfo.id}</h2>
              <div className="purchaseOrderControls">
                <h4>Order Total: {numeral(orderBasicInfo.grand_total).format('$0,0.00')}</h4>
              </div>
            </div>
            {!this.state.isEditing && <p>{orderBasicInfo.description}</p>}
            {this.state.isEditing && (
              <TextArea onChange={this.handleDescriptionChange} value={this.state.description} />
            )}
            <div className="row" data-html2canvas-ignore="true">
              <div className="col-md-12 text-right">
                {!this.state.isEditing && (
                  <Button icon="edit" className="marginRight10" onClick={() => this.handleEdit()} />
                )}
                {this.state.isEditing && (
                  <Button icon="save" className="marginRight10" onClick={() => this.handleSave()} />
                )}
                {loadingRevision ? (
                  <Spin size="small" className="marginRight10" />
                ) : (
                  <a
                    href={`${API_BASE}/api/vendor/purchase_orders/print/${
                      orderBasicInfo.id
                    }?revision=${this.state.currentRevisionNumberPrint}`}
                    target="_blank"
                  >
                    <Button icon="printer" className="marginRight10" />
                  </a>
                )}

                <Popconfirm
                  title="Are you sure you want to delete this purchase order?"
                  onConfirm={this.props.handleDeletePurchaseOrder}
                  onCancel={this.cancelDelete}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button type="danger" icon="delete" />
                </Popconfirm>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <h4>Terms</h4>
                {!this.state.isEditing && <p className="formHighlightText">{this.state.terms}</p>}
                {this.state.isEditing && (
                  <Input onChange={this.handleTermsChange} value={this.state.terms} />
                )}
              </div>
              <div className="col-md-6">
                <FormItem label="Revision">
                  {loadingRevision ? (
                    <Spin size="small" />
                  ) : (
                    <Select
                      defaultValue={
                        revisions ? revisions[revisions.length - 1].currentRevisionNumber : null
                      }
                      onChange={this.handleRevisionChange}
                    >
                      {revisions &&
                        revisions.map(revision => (
                          <Option
                            key={revision.currentRevisionNumber}
                            value={revision.currentRevisionNumber - 1} // revision index
                          >
                            {revision.currentRevisionNumber}
                          </Option>
                        ))}
                    </Select>
                  )}
                </FormItem>
              </div>

              <div className="col-md-6">
                <h4>Ship To</h4>
                <div className="formHighlightText">
                  {!this.state.isEditing && <p>{shipTo}</p>}
                  {this.state.isEditing && (
                    <RadioGroup
                      value={this.state.shipTo}
                      onChange={event => this.handleShipToChange(event.target.value)}
                    >
                      <RadioButton value={1}>G-Tech</RadioButton>
                      <RadioButton value={2}>Jobsite</RadioButton>
                      <RadioButton value={3}>Client</RadioButton>
                      <RadioButton
                        value={isOtherShippingOption && this.state.shipTo ? this.state.shipTo : 4}
                      >
                        Other
                      </RadioButton>
                    </RadioGroup>
                  )}
                  {this.renderSelectedShipping(isOtherShippingOption)}
                </div>
              </div>
            </div>
            {!this.state.isEditing && orderSections}
          </div>

          {this.state.isEditing && (
            <div>
              <PurchaseOrderEditor
                moveItemUp={this.moveItemUp}
                moveItemDown={this.moveItemDown}
                deleteItem={this.deleteItem}
                onSectionNameChange={this.onSectionNameChange}
                purchaseOrderSections={this.state.purchaseOrderSections}
                purchaseOrderItems={this.state.purchaseOrderItems}
                addSection={this.addSection}
                allItems={this.props.allItems}
                moveSectionDown={this.moveSectionDown}
                moveSectionUp={this.moveSectionUp}
                deleteSection={this.deleteSection}
                addItem={this.addItem}
                createNewItem={this.props.createNewItem}
                onChangeItem={this.onChangeItem}
                onChangeName={this.onChangeName}
                allowEdit={true}
              />
            </div>
          )}
        </Modal>
        <div className="row">
          <div className="col-md-2">
            <div className="jobDetailsHeader">Phone Number</div>
            <TextMask
              Component={SpanAdapter}
              value={vendor.work_number}
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                'e',
                'x',
                't',
                ':',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              guide
            />
          </div>
          <div className="col-md-2">
            <div className="jobDetailsHeader">Fax Number</div>
            <TextMask
              Component={SpanAdapter}
              value={vendor.fax_number}
              mask={[
                '(',
                /[1-9]/,
                /\d/,
                /\d/,
                ')',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                '-',
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                ' ',
                'e',
                'x',
                't',
                ':',
                ' ',
                /\d/,
                /\d/,
                /\d/,
                /\d/
              ]}
              guide
            />
          </div>
          <div className="col-md-8 text-right">
            <Popconfirm
              title="Are you sure you want to delete this Vendor?"
              onConfirm={this.props.deleteVendor}
              okText="Yes"
              cancelText="No"
            >
              <Button type="danger" icon="delete" className="ml-2" />
            </Popconfirm>
          </div>
        </div>
        <br />
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                <Icon type="file-text" />Purchase Orders
              </span>
            }
            key="1"
          >
            <Button onClick={() => handleAddPurchaseOrderClick(vendor.organization_id)}>
              Add Purchase Order
            </Button>
            <br />
            <br />
            <ReactTable
              getTrProps={(state, rowInfo, column, instance) => ({
                onClick: e => this.handleRowClick(rowInfo.original)
              })}
              data={filteredData}
              defaultFilterMethod={filterCaseInsensitive}
              columns={[
                {
                  columns: [
                    {
                      Header: 'Identification',
                      accessor: 'id'
                    },
                    {
                      Header: 'Description',
                      accessor: 'description'
                    },
                    {
                      Header: 'Grand Total',
                      id: 'grand_total',
                      accessor: d => {
                        const r = numeral(d.grand_total).format('$0,0.00')
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      maxWidth: 200
                    },
                    {
                      Header: 'Created By',
                      id: 'created_by',
                      accessor: d => {
                        const r = `${d.created_by_first_name} ${d.created_by_last_name}`
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 160
                    },
                    {
                      Header: 'Updated By',
                      id: 'updated_by',
                      accessor: d => {
                        const r = `${d.updated_by_first_name} ${d.updated_by_last_name}`
                        return <Tooltip title={r}>{r}</Tooltip>
                      },
                      width: 160
                    },
                    {
                      Header: 'Created Date',
                      id: 'created_date',
                      accessor: d => moment.utc(d.created_date).format('M/D/YYYY'),
                      minWidth: 70
                    },
                    {
                      Header: 'Updated Date',
                      id: 'update_date',
                      accessor: d => moment.utc(d.updated_date).format('M/D/YYYY'),
                      minWidth: 70
                    }
                  ]
                }
              ]}
              defaultPageSize={5}
              className="-striped -highlight"
            />
          </TabPane>
          <TabPane
            tab={
              <span>
                <Icon type="paper-clip" />Attachments
              </span>
            }
            key="2"
          >
            <FilesUploadContainer>
              <div className="row">
                <div className="col-md-6">
                  <h5>
                    <Icon type="check" /> Vendor Files
                  </h5>
                </div>
                <div className="col-md-6 text-right">
                  {this.props.uploadingAttachments && (
                    <div className="text-success">
                      <Icon type="loading" /> Uploading File(s)
                    </div>
                  )}
                  {this.props.deletingAttachment && (
                    <div className="text-danger">
                      <Icon type="loading" /> Deleting File(s)
                    </div>
                  )}
                </div>
              </div>
              {this.props.jobVendorAttachments &&
                this.props.jobVendorAttachments.length > 0 && (
                  <Spin spinning={this.props.loadingAttachments}>
                    <ReactTable
                      defaultPageSize={5}
                      defaultFilterMethod={filterCaseInsensitive}
                      data={this.props.jobVendorAttachments}
                      getTrProps={(state, rowInfo, column, instance) => ({
                        onClick: e => this.props.handleAttachmentRowClick(rowInfo.original)
                      })}
                      columns={[
                        {
                          Header: 'Attached Files',
                          columns: [
                            {
                              Header: 'Filename',
                              id: 'filename',
                              accessor: 'filename',
                              Cell: d => (
                                <Tooltip title={d.original.filename}>{d.original.filename}</Tooltip>
                              )
                            },
                            {
                              Header: 'Description',
                              id: 'description',
                              accessor: d => (
                                <Tooltip title={d.description}>{d.description}</Tooltip>
                              )
                            },
                            {
                              Header: 'Created by',
                              id: 'created_by',
                              accessor: d => {
                                const name = `${d.created_by_first_name} ${d.created_by_last_name}`
                                return <Tooltip title={name}>{name}</Tooltip>
                              }
                            },
                            {
                              Header: 'Updated by',
                              id: 'updated_by',
                              accessor: d => {
                                const name = `${d.updated_by_first_name} ${d.updated_by_last_name}`
                                return <Tooltip title={name}>{name}</Tooltip>
                              }
                            },
                            {
                              Cell: row => (
                                <Tooltip placement="left" title="Open this file on a new window">
                                  <a target="_blank" href={row.original.signedUrl}>
                                    <Icon type="export" className="fontSize20" />
                                  </a>
                                </Tooltip>
                              ),
                              maxWidth: 35
                            }
                          ]
                        }
                      ]}
                      defaultSorted={[
                        {
                          id: 'id',
                          desc: true
                        }
                      ]}
                      className="-striped -highlight"
                    />
                  </Spin>
                )}
              {this.props.attachmentDetailsVisible && (
                <EditAttachmentContainer>
                  <EditAttachmentTitle>
                    <Icon type="edit" /> Edit Attachment Area
                  </EditAttachmentTitle>
                  <div>
                    <EditingFileContainer>
                      <Icon type="file" /> {this.props.attachmentName}
                    </EditingFileContainer>
                  </div>
                  <div className="row">
                    <div className="col-md-10">
                      <TextArea
                        placeholder="Describe the attachment..."
                        rows={4}
                        onChange={this.props.onDescriptionChange}
                        value={this.props.attachmentDescription}
                      />
                    </div>
                  </div>
                  <div className="d-flex flex-row mt-2">
                    <Button onClick={this.props.handleUpdateAttachmentDescription}>
                      <Icon type="save" /> OK
                    </Button>{' '}
                    <Popconfirm
                      title="Are you sure you want to delete this attachment?"
                      onConfirm={this.props.confirmAttachmentDelete}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Button type="danger" icon="delete" className="ml-2">
                        {' '}
                        DELETE
                      </Button>
                    </Popconfirm>
                  </div>
                </EditAttachmentContainer>
              )}
              <br />
              <div>Upload Vendor File(s)</div>
              <br />
              <Upload
                {...uploadProps}
                name="file"
                customRequest={this.props.uploadVendorAttachment}
              >
                <Button>
                  <Icon type="upload" /> Upload
                </Button>
              </Upload>
            </FilesUploadContainer>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}

const mapStateToProps = ({ vendorActions }, ownProps) => ({
  vendorActions
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign(vendorActions), dispatch)
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Form.create()(VendorPanel)))



// WEBPACK FOOTER //
// ./src/components/VendorPanel.js